import React from 'react';

import './App.css';

import { Component } from 'react';
import { RouteProps } from 'react-router';

import AWS from 'aws-sdk';

interface Props {
  
}

interface State {
  input: string;
  output: string;
}

export default class extends Component<Props & RouteProps, State> {
  state = {
    input: "",
    output: "",
  };

  componentWillMount = () => {
  }

  onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let output = '';

    try {
      output = JSON.stringify(AWS.DynamoDB.Converter.unmarshall(JSON.parse(e.target.value)), null, 2);
    } catch (e) {

    }

    this.setState({
      input: e.target.value,
      output: output,
    });
  }

  render = () => {
    return (
      <div>
        <textarea value={this.state.input} onChange={this.onChange} style={{width: '800px', height: '400px'}}></textarea>
        <textarea value={this.state.output} style={{width: '800px', height: '400px'}}></textarea>
      </div>
    )
  }
}
